import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import {
  useItemGroupFilteredQuery,
  useItemGroupMutation,
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
  usePostUpdateItemGroupMutation
} from "../../../../store/api/itemapi";
import { useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManager from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
const EditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const IdData = location.state?.ItemId;
  const [podata, setpodata] = useState('')
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

   const { data: itemdata1 } = useItemGroupFilteredQuery()
  useEffect(() => {
    if (itemdata1) {
      setParentItemGroup_list(itemdata1.data);

    }

  }, [itemdata1])


  // api varibale
  const [ParentItemGroupApi] = useItemGroupMutation();

  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  const [UpdateItemGroup] = usePostUpdateItemGroupMutation();

  // tab1
  const [ItemGroupName, setItemGroupName] = useState("");
  const [select_ParentItemGroup, setselect_ParentItemGroup] = useState("");
  const [ParentItemGroup_list, setParentItemGroup_list] = useState([]);
  const [UnicommerceProductCategoryCode, setUnicommerceProductCategoryCode] =
    useState("");
  const [IsGroup, setIsGroup] = useState("");

  const [selected_default_item_data, setselected_default_item_data] =
    useState([]);
  const [selected_tax_item_data, setselected_tax_item_data] =
    useState([]);
  // console.log('tax:',selected_default_item_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    ItemGroupName: false,
    UnicommerceProductCategoryCode: false,
  });


  // useEffect(() => {
  //   const getParentItemGroup = async () => {
  //     const ParentItemGroupApiData = await ParentItemGroupApi();
  //     setParentItemGroup_list(ParentItemGroupApiData.data.data);
  //   };

  //   getParentItemGroup();

  // }, []);
  const [status, setStatus] = useState("");
  const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

  useEffect(() => {
    if (IdData) {
      itemDetails({ doctype: 'Item Group', name: IdData })
        .unwrap()
        .then((response) => {
          const item = response.docs?.[0]; // ✅ safely access first item
          const docinfo = response.docinfo;

          if (!item) return;
          setpodata(response)
          console.log(item, "Api response");
          setItemGroupName(item.item_group_name);
          setselect_ParentItemGroup(item.parent_item_group);
          setUnicommerceProductCategoryCode("");
          setIsGroup(item.is_group);
          setselected_default_item_data(item.item_group_defaults)
          setselected_tax_item_data(item.taxes)
          // console.log("r1:",iteme.item_group_defaults);
          setStatus(item.is_group)
          setAttachmentsList(docinfo.attachments); // ✅ Correct place
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } else {
      console.warn('No Id Data found in location state');
    }
  }, [IdData, itemDetails]);
  const handleSubmit = async () => {
    console.log('tbl1:', selected_default_item_data)
    console.log('tbl2:', selected_tax_item_data)
    setFieldErrors({
      ItemGroupName: false,
      // UnicommerceProductCategoryCode: false,
    });

    let hasError = false;
    const newErrors = {
      ItemGroupName: !ItemGroupName,
      // UnicommerceProductCategoryCode: !UnicommerceProductCategoryCode,
    };
    const FirsthasInvalidItem = "";
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);


    if (!ItemGroupName) {
      setptype("Error");
      setError("Please fill Item Group Name.");
      setShowError(true);
      return;
    }
    // if (!UnicommerceProductCategoryCode) {
    //   setptype("Error");
    //   setError("Please fill Unicommerce Product Category Code.");
    //   setShowError(true);
    //   return;
    // }


    const payload = {
      name: IdData,
      docstatus: 0,
      doctype: "Item Group",
      item_group_name: ItemGroupName,
      parent_item_group: select_ParentItemGroup,
      is_group: IsGroup,
      image: "",
      gst_hsn_code: "",
      item_group_defaults: selected_default_item_data ? selected_default_item_data : [],
      taxes: selected_tax_item_data ? selected_tax_item_data : []
    };

    console.log('update item group payload:', payload)
    try {
      const response = await UpdateItemGroup(payload).unwrap(); // This throws if error occurs

      // ✅ Success handling
      setpo_response(response.data);
      setError("Item Group updated successfully!");
      setptype("Success");
      setShowError(true);

      setTimeout(() => {
        navigate("/master/itemgroup/item-group-list");
      }, 2000);
    } catch (err) {
      // ✅ Error handling
      let errorMessage = "Updation failed";

      const stripHTML = (html) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
      };

      try {
        const data = err?.data;

        // First: Try _server_messages
        const serverMessages = data?._server_messages;
        if (serverMessages) {
          const parsedServer = JSON.parse(serverMessages);
          if (Array.isArray(parsedServer) && parsedServer.length > 0) {
            const parsedMessage = JSON.parse(parsedServer[0]);
            if (parsedMessage?.message) {
              errorMessage = parsedMessage.message;
            }
          }
        }

        // Second: Try exception or message
        if (
          (!errorMessage || errorMessage === "Updation failed") &&
          (data?.exception || data?.message)
        ) {
          const rawException = data.exception || data.message;
          errorMessage = rawException.split(":").pop()?.trim();
        }
      } catch (e) {
        console.warn("Error parsing error response:", e);
      }

      errorMessage = stripHTML(errorMessage);
      setptype("Error");
      setError(errorMessage || "Unexpected error occurred.");
      setShowError(true);
    }

  };
  return (
    <FormLayout
      title="Edit Item Group"
      breadcrumbs={[
        { label: "Item Group" },
        { label: "Item Group List", url: "/master/itemgroup/item-group-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => { }}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="#"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            {/* <FileAttachmentManager
  doctype="Item Group"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}

            <Attachment doctype="Item Group" docname={IdData} />

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    ItemGroupName={{
                      ItemGroupName: ItemGroupName,
                      setItemGroupName: setItemGroupName,
                      ItemGroupName: ItemGroupName,
                      Error: fieldErrors.ItemGroupName,
                    }}
                    ParentItemGroup={{ ParentItemGroup_list: ParentItemGroup_list, setselect_ParentItemGroup: setselect_ParentItemGroup, select_ParentItemGroup: select_ParentItemGroup, Error: fieldErrors.ParentItemGroup }}
                    UnicommerceProductCategoryCode={{
                      UnicommerceProductCategoryCode:
                        UnicommerceProductCategoryCode,
                      setUnicommerceProductCategoryCode:
                        setUnicommerceProductCategoryCode,
                      Error: fieldErrors.UnicommerceProductCategoryCode,
                    }}
                    IsGroup={{
                      IsGroup: IsGroup,
                      setIsGroup: setIsGroup,
                      Error: fieldErrors.IsGroup,
                    }}
                  />
                  <Tab2
                    setselected_default_item_data={setselected_default_item_data} selected_default_item_data={selected_default_item_data}
                  />
                  <Tab3
                    ItemGroupName={{
                      ItemGroupName: ItemGroupName,
                      setItemGroupName: setItemGroupName,
                      ItemGroupName: ItemGroupName,
                      Error: fieldErrors.ItemGroupName,
                    }}
                    setselected_tax_item_data={setselected_tax_item_data} selected_tax_item_data={selected_tax_item_data}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default EditForm;
